import { TGroupTreeNode } from '@/shared/features/groups/components/group-list/group-shell-context.types';

export const findGroupInTree = (
  nodes: TGroupTreeNode[],
  groupId: string,
): boolean =>
  nodes.some(
    (node) =>
      node.groupId === groupId || findGroupInTree(node.subGroups, groupId),
  );
